import { ConfigBIMulticonta } from './../../../models/config-bi-multiconta.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbConfigBiMulticonta } from 'app/abstract/full-pages/config-bi-multiconta/config-bi-multiconta.abstract';


@Injectable({ providedIn: 'root' })
export class ConfigBIMultiContaService extends AbConfigBiMulticonta {
  constructor(http: HttpClient) {
    super(http);
  }

  public getConfiguracaoBIMultiConta(): Observable<any> {
    return this.get(`config_bi_multiconta/`);
  }

  public saveConfiguracaoBIMulticonta(cfg: ConfigBIMulticonta): Observable<any> {
    return this.save(`config_bi_multiconta/`, cfg);
  }

  public deleteConfiguracaoBIMulticonta(id: number): Observable<any> {
    return this.delete(`config_bi_multiconta/`, id);
  }
}
